var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 100,
    viewBox: "0 0 138 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_16246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3656 99.1667C84.3962 91.8474 91.1461 82.2952 92.8867 79.5058C93.2007 79.0091 93.3669 78.4333 93.3661 77.8457V42.8383C93.3658 42.129 93.1242 41.441 92.681 40.8872C92.2378 40.3335 91.6193 39.9471 90.9273 39.7915L69.5967 35.0042C69.1464 34.9045 68.6797 34.9045 68.2293 35.0042L46.9019 39.7915C46.2099 39.9471 45.5914 40.3335 45.1482 40.8872C44.705 41.441 44.4634 42.129 44.4632 42.8383V77.8392C44.4626 78.4264 44.6276 79.0018 44.9393 79.4994C46.696 82.2888 53.4458 91.8409 67.4765 99.1603C67.9214 99.3954 68.4169 99.5189 68.9202 99.52C69.4235 99.5211 69.9196 99.3999 70.3656 99.1667Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7472 39.8559L48.8707 44.3118C48.6872 44.3559 48.524 44.4605 48.4073 44.6088C48.2905 44.757 48.2271 44.9403 48.2273 45.129V65.398H68.9338V39.8333C68.8708 39.8324 68.8081 39.84 68.7472 39.8559Z",
    fill: "url(#paint0_linear_752_16246)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9307 65.3981V94.7913C69.059 94.7912 69.1857 94.7615 69.3007 94.7044C82.7908 87.9481 88.6495 78.6179 89.5181 77.1508C89.5944 77.0223 89.6344 76.8756 89.634 76.7262V65.3981H68.9307Z",
    fill: "url(#paint1_linear_752_16246)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.992 68.9306C13.992 54.3599 19.7802 40.3861 30.0831 30.0831C40.3861 19.7802 54.3599 13.992 68.9305 13.992C83.5011 13.992 97.475 19.7802 107.778 30.0831C118.081 40.3861 123.869 54.3599 123.869 68.9306",
    stroke: "#05CB67",
    strokeWidth: 0.643459,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.46 1.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9888 82.4336C21.4481 82.4336 27.495 76.3867 27.495 68.9274C27.495 61.4681 21.4481 55.4212 13.9888 55.4212C6.52951 55.4212 0.482574 61.4681 0.482574 68.9274C0.482574 76.3867 6.52951 82.4336 13.9888 82.4336Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.866 82.4336C131.325 82.4336 137.372 76.3867 137.372 68.9274C137.372 61.4681 131.325 55.4212 123.866 55.4212C116.407 55.4212 110.36 61.4681 110.36 68.9274C110.36 76.3867 116.407 82.4336 123.866 82.4336Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9272 27.4951C76.3865 27.4951 82.4334 21.4481 82.4334 13.9889C82.4334 6.5296 76.3865 0.482666 68.9272 0.482666C61.4679 0.482666 55.421 6.5296 55.421 13.9889C55.421 21.4481 61.4679 27.4951 68.9272 27.4951Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8584 38.3631C40.0436 38.3631 41.0044 37.4023 41.0044 36.2172C41.0044 35.032 40.0436 34.0712 38.8584 34.0712C37.6733 34.0712 36.7125 35.032 36.7125 36.2172C36.7125 37.4023 37.6733 38.3631 38.8584 38.3631Z",
    stroke: "#05CB67",
    strokeWidth: 1.60865,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.726 16.9585C106.139 16.9585 107.284 15.8133 107.284 14.4007C107.284 12.9881 106.139 11.843 104.726 11.843C103.314 11.843 102.169 12.9881 102.169 14.4007C102.169 15.8133 103.314 16.9585 104.726 16.9585Z",
    stroke: "#05CB67",
    strokeWidth: 1.60865,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8427 46.6411C12.6814 46.6411 13.3613 45.9612 13.3613 45.1225C13.3613 44.2838 12.6814 43.6039 11.8427 43.6039C11.004 43.6039 10.3242 44.2838 10.3242 45.1225C10.3242 45.9612 11.004 46.6411 11.8427 46.6411Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3182 68.2035C34.1568 68.2035 34.8367 67.5236 34.8367 66.6849C34.8367 65.8463 34.1568 65.1664 33.3182 65.1664C32.4795 65.1664 31.7996 65.8463 31.7996 66.6849C31.7996 67.5236 32.4795 68.2035 33.3182 68.2035Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.687 80.1878C104.526 80.1878 105.206 79.5079 105.206 78.6693C105.206 77.8306 104.526 77.1507 103.687 77.1507C102.848 77.1507 102.169 77.8306 102.169 78.6693C102.169 79.5079 102.848 80.1878 103.687 80.1878Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.493 38.54V42.9284",
    stroke: "#05CB67",
    strokeWidth: 1.28692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.687 40.7342H99.2988",
    stroke: "#05CB67",
    strokeWidth: 1.28692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6958 64.3265C18.7122 63.6983 18.6026 63.0731 18.3736 62.4878C18.1445 61.9026 17.8006 61.3692 17.362 60.919C16.9234 60.4688 16.3992 60.111 15.8201 59.8667C15.2411 59.6224 14.6189 59.4966 13.9905 59.4966C13.362 59.4966 12.7399 59.6224 12.1608 59.8667C11.5818 60.111 11.0575 60.4688 10.619 60.919C10.1804 61.3692 9.83646 61.9026 9.60738 62.4878C9.3783 63.0731 9.26875 63.6983 9.28518 64.3265V66.9004H10.8295V64.3265C10.8557 63.5056 11.2002 62.7271 11.7901 62.1557C12.3801 61.5843 13.1692 61.2648 13.9905 61.2648C14.8118 61.2648 15.6009 61.5843 16.1908 62.1557C16.7808 62.7271 17.1253 63.5056 17.1515 64.3265V66.9004H18.6958V64.3265Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6447 66.9005H8.3327C7.73034 66.9005 7.24203 67.3888 7.24203 67.9911V75.925C7.24203 76.5273 7.73034 77.0156 8.3327 77.0156H19.6447C20.2471 77.0156 20.7354 76.5273 20.7354 75.925V67.9911C20.7354 67.3888 20.2471 66.9005 19.6447 66.9005Z",
    fill: "url(#paint2_linear_752_16246)",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9889 72.7656C14.5255 72.7656 14.9606 72.3306 14.9606 71.7939C14.9606 71.2573 14.5255 70.8223 13.9889 70.8223C13.4523 70.8223 13.0173 71.2573 13.0173 71.7939C13.0173 72.3306 13.4523 72.7656 13.9889 72.7656Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.989 72.7625V74.8666",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0789 19.1235V6.38626C75.078 6.27303 75.0327 6.16468 74.9526 6.08462C74.8726 6.00455 74.7642 5.95922 74.651 5.95837H63.2071C63.0942 5.95922 62.9861 6.00468 62.9066 6.08484C62.827 6.16499 62.7824 6.27333 62.7824 6.38626V21.5944C62.7824 21.7071 62.8271 21.8151 62.9068 21.8947C62.9864 21.9744 63.0945 22.0191 63.2071 22.0191H72.1833L75.0789 19.1235Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0755 18.847H71.9032V22.0192",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9734 11.1351L63.9117 9.8836L64.3975 9.46857L65.012 10.1892L66.582 8.6192L67.0357 9.07284L64.9734 11.1351Z",
    fill: "url(#paint3_linear_752_16246)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4285 9.53601H67.7628V10.2181H73.4285V9.53601Z",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9734 14.896L63.9117 13.6413L64.3975 13.2263L65.012 13.9501L66.582 12.3769L67.0357 12.8305L64.9734 14.896Z",
    fill: "url(#paint4_linear_752_16246)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4285 13.2971H67.7628V13.9791H73.4285V13.2971Z",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9734 18.6539L63.9117 17.4023L64.3975 16.9873L65.012 17.708L66.582 16.1379L67.0357 16.5916L64.9734 18.6539Z",
    fill: "url(#paint5_linear_752_16246)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4285 17.0549H67.7628V17.737H73.4285V17.0549Z",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.975 77.7428V60.3307",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.975 68.6795C119.018 68.6795 119.864 67.834 119.864 66.791C119.864 65.7479 119.018 64.9024 117.975 64.9024C116.932 64.9024 116.086 65.7479 116.086 66.791C116.086 67.834 116.932 68.6795 117.975 68.6795Z",
    fill: "url(#paint6_linear_752_16246)",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.866 60.3307V77.7428",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.866 73.1708C124.909 73.1708 125.754 72.3253 125.754 71.2823C125.754 70.2393 124.909 69.3937 123.866 69.3937C122.823 69.3937 121.977 70.2393 121.977 71.2823C121.977 72.3253 122.823 73.1708 123.866 73.1708Z",
    fill: "url(#paint7_linear_752_16246)",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.76 77.7428V60.3307",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.76 68.6795C130.803 68.6795 131.648 67.834 131.648 66.791C131.648 65.7479 130.803 64.9024 129.76 64.9024C128.717 64.9024 127.871 65.7479 127.871 66.791C127.871 67.834 128.717 68.6795 129.76 68.6795Z",
    fill: "url(#paint8_linear_752_16246)",
    stroke: "#333333",
    strokeWidth: 0.965189,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_752_16246",
    x1: 37.3271,
    y1: 76.34,
    x2: 79.2999,
    y2: 34.3704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_752_16246",
    x1: 31339.4,
    y1: 30744.3,
    x2: 34949.9,
    y2: 28201.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_752_16246",
    x1: 7.24203,
    y1: 71.958,
    x2: 20.7354,
    y2: 71.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_752_16246",
    x1: 684.494,
    y1: 85.8581,
    x2: 714.828,
    y2: 85.8581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_752_16246",
    x1: 684.494,
    y1: 119.138,
    x2: 714.828,
    y2: 119.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_752_16246",
    x1: 684.494,
    y1: 152.174,
    x2: 714.828,
    y2: 152.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_752_16246",
    x1: 1478.94,
    y1: 849.03,
    x2: 1523.32,
    y2: 849.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_752_16246",
    x1: -12665.3,
    y1: -3812.81,
    x2: -12709.7,
    y2: -3812.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_752_16246",
    x1: 1629.04,
    y1: 849.03,
    x2: 1673.42,
    y2: 849.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_16246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137.855,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefense);
export default __webpack_public_path__ + "static/media/defense.9cd1ea6b8808242ffb0347557b40d1a1.svg";
export { ForwardRef as ReactComponent };